import React from 'react';
import { bodyFontSizes, titleFontSizes } from '../helpers/utils';
const TextOverlay = ({
  text
}) => {
  const {
    position,
    title,
    title_empty,
    title_color,
    title_font_family,
    title_font_size,
    body,
    body_empty,
    body_color,
    body_font_family,
    body_font_size
  } = text;
  const titleFontSize = titleFontSizes[title_font_size];
  const bodyFontSize = bodyFontSizes[body_font_size];
  const titleExtraClassName = titleFontSizes[title_font_size] === titleFontSizes.xlarge ? 'xlarge' : '';
  const bodyExtraClassName = bodyFontSizes[body_font_size] === bodyFontSizes.xlarge ? 'xlarge' : '';
  return /*#__PURE__*/React.createElement("span", {
    className: `TextOverlay ${position}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `line header ${title_color === 'auto' ? 'auto-color' : ''} ${title_empty ? 'empty-text' : ''} ${titleExtraClassName}`,
    style: {
      color: title_color === 'auto' ? 'white' : title_color,
      fontFamily: title_font_family,
      fontSize: `${titleFontSize}%`
    }
  }, title), /*#__PURE__*/React.createElement("div", {
    className: `line text ${body_color === 'auto' ? 'auto-color' : ''} ${body_empty ? 'empty-text' : ''} ${bodyExtraClassName}`,
    style: {
      color: body_color === 'auto' ? 'white' : body_color,
      fontFamily: body_font_family,
      fontSize: `${bodyFontSize}%`
    }
  }, body));
};
export default TextOverlay;